import Duration from "~/components/shared/Duration";

interface NodeDurationProps {
  startedAt?: string | null;
  finishedAt?: string | null;
}

/**
 * Renders a step duration for canvas nodes with a placeholder when the step hasn't started yet.
 */
export function NodeDuration({ startedAt, finishedAt }: NodeDurationProps) {
  return (
    // min-w-[7ch] + tabular-nums ensures consistent width for max duration text, eg. "50m 30s"
    <span className="inline-block min-w-[7ch] text-right tabular-nums">
      {startedAt ? (
        <Duration.Short from={startedAt} to={finishedAt} />
      ) : (
        <span aria-hidden="true">--</span>
      )}
    </span>
  );
}
